<template>
  <div>
    <b-modal id="modal-edit" size="lg" centered :title="$store.state.modal.editAsuransi" header-bg-variant="warning" header-text-variant="light">
      <b-form>
        <!-- Nama -->
        <b-form-group :label="$store.state.table.lateFines" label-cols-md="3">
          <b-form-input type="text" v-model="$v.data.nama.$model" :state="checkIfValid('nama')" autofocus v-on:keydown.enter.prevent="simpan()" />
        </b-form-group>

        <!-- Nominal -->
        <b-form-group :label="$store.state.table.nominal" label-cols-md="3">
          <b-form-input type="number" v-model="$v.data.nominal.$model" :state="checkIfValid('nominal')" v-on:keydown.enter.prevent="simpan()" />
        </b-form-group>

        <!-- Berlaku (active switch) -->
        <b-form-group :label="$store.state.table.active" label-cols-md="3">
          <b-form-checkbox v-model="$v.data.berlaku.$model" :state="checkIfValid('berlaku')" switch>
            {{ data.berlaku ? $store.state.form.aktif : $store.state.form.nonaktif }}
          </b-form-checkbox>
        </b-form-group>

        <!-- Deskripsi -->
        <b-form-group :label="$store.state.table.deskripsi" label-cols-md="3">
          <b-form-textarea v-model="$v.data.deskripsi.$model" :state="checkIfValid('deskripsi')" rows="3" max-rows="6" />
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "modalEdit",
  props: ["data"],
  data() {
    return {
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      nama: { required },
      nominal: { required, minValue: minValue(0) },
      berlaku: { required },
      deskripsi: { required },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = vm.$store.state.form.tunggu;
        vm.$axios
          .post("dendaTerlambat/update", vm.data)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              this.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGUBAH DATA DENDA",
                showing: true,
              });
              this.$bvModal.hide("modal-edit");
            } else {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = vm.$store.state.form.simpan;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
  watch: {
    lang: function () {
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>
